import React, { useContext } from "react";
import { ChatContext } from './Context';
import {sendMessageToRasa, handleRasaResponse, mergeButtonData } from '../../utils/chatbot/chatbotUtils';
import styles from "./Chatbot.module.scss";
import MessagePartsContainer from './Message';
import ButtonMessage from './ButtonMessage';
import CheckboxMessage from './CheckboxMessage';
import { bottomNavigationActionClasses } from "@mui/material";

type MessageListProp = {
    messagesContainerRef: React.RefObject<HTMLDivElement>;
    endOfMessagesRef: React.RefObject<HTMLDivElement>;
};

const MessageList: React.FC<MessageListProp> = ({ messagesContainerRef, endOfMessagesRef }) => {
    const { messages, setMessages } = useContext(ChatContext);

    const addMessage = (message: any) => {
        setMessages((prevMessages: any) => [...prevMessages, message]);
    };

    const handleButtonClick = async (button: any) => {
        const userMessage = { sender: "user", message: button.title }
        setMessages((prevMessages: any) => [...prevMessages, userMessage]);
        try {
            const response = await sendMessageToRasa("user", button.payload);
            console.log("Rasa Response: ", response);
            handleRasaResponse(response, addMessage);
        } catch (error) {
            console.error("Error sending message to Rasa:", error);
        }
    };
    
    const handleSendSelected = async (selectedCheckboxes: string[], rasa_slot_name: string, rasa_next_intent: string) => {

        const checkboxesJson = JSON.stringify(selectedCheckboxes);
        const payload = `/${rasa_next_intent}{"${rasa_slot_name}" : ${checkboxesJson}}`;

        try {
            const response = await sendMessageToRasa("user", payload);
            handleRasaResponse(response, addMessage);
        } catch(error) {
            console.error("Error sending message to Rasa: ", error);
        }
      };
    
    // console.log("Messages:", messages);
    
    return (
        <div className={styles.content} ref={messagesContainerRef}>
            <div className={styles.chatbox__messages}>  
                {messages &&
                    messages
                        .slice()
                        .reverse()
                        .map((message: any, idx: number) => {
                            if (message.message && message.message.trim() !== "") {
                                const messageParts = message.message?.split("\n");
                                return (
                                    <React.Fragment key={`message-${idx}`}>
                                        {message.buttons && message.buttons.length > 0 && (
                                            <ButtonMessage
                                                buttons={mergeButtonData(message.buttons)}
                                                handleButtonClick={handleButtonClick} 
                                            />
                                        )}
                                        {message.checkboxes && message.checkboxes.length > 0 && (
                                            <CheckboxMessage
                                                key={`checkbox-message-${idx}`}
                                                checkboxes={message.checkboxes}
                                                rasa_slot_name={message.checkbox_slot_name}
                                                rasa_next_intent={message.next_intent}
                                                handleSendSelected={handleSendSelected}
                                            />
                                        )}
                                        {messageParts && messageParts[0].trim() !== '{message}' &&
                                            messageParts[0].trim() !== "" && messageParts[0] !== "" && (
                                                <MessagePartsContainer
                                                    messageParts={messageParts}
                                                    sender={message.sender} />
                                            )}
                                    </React.Fragment>
                                );
                            }
                            return null;
                        })
                }
                <div />
            </div>
            <div ref={endOfMessagesRef} />
        </div>
    );
};

export default MessageList;